module.exports = __webpack_public_path__ + "../resources/img/ic_dropdown_arrow_up.4d321ec0.svg";